module.exports = __webpack_public_path__ + "media/V34.2c68443e.mp4";